import React, { useState, useEffect, useMemo } from 'react'
import lodash from 'lodash'
import { useRecoilState } from 'recoil'

import { toast } from '../../../../1stlog-ui/src/utils'
import { useFieldContext } from '../../../../1stlog-ui/src/components/Field'
import { relevantAddressProps } from '../../OrderEntry/utils'
import { isLoadingStateFamily } from './state'
import { requestAdd, requestUpdate } from './requests'

const useAddressBook = () => {
  const { prefix } = useFieldContext()

  const [isLoading, setIsLoading] = useRecoilState(isLoadingStateFamily(prefix))

  // save new address
  const create = async (values) => {
    try {
      setIsLoading(true)
      const payload = lodash.pick(values, relevantAddressProps)
      const result = await requestAdd(payload)
      toast.success('Adresse wurde gespeichert.')
      return result
    } catch (err) {
      console.error('Failed to add address to addressbook', err)
      toast.error('Hinzufügen der Adresse fehlgeschlagen!')
      return undefined
    } finally {
      setIsLoading(false)
    }
  }

  const update = async (values) => {
    try {
      setIsLoading(true)
      const payload = values
      const result = await requestUpdate(payload)
      toast.success('Adresse wurde aktualisiert.')
      return result
    } catch (err) {
      console.error('Failed to update address in addressbook', err)
      toast.error('Aktualisieren der Adresse fehlgeschlagen!')
      return undefined
    } finally {
      setIsLoading(false)
    }
  }

  const remove = (values) => {
    // TODO: not needed here yet
  }

  // update existing address

  // load all addresses

  return { isLoading, create, update }
}

export default useAddressBook
